<template>
    <div class="order-item-option-group">
        <div class="name" v-if="shouldDisplayName">{{ optionGroupName }}</div>
        <div class="entries" v-if="optionGroup.items.length">
            <OrderItemOption
                v-for="option in optionGroup.items"
                :key="option.id"
                :option="option"
                :multiplier="multiplier"
                :showInternalNames="props.showInternalNames"
                :alwaysShowGroupName="props.alwaysShowGroupName"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
    import type { IOrderOptionGroup } from "@/data/model/Order";
    import { getName } from "@/shared/helpers/ItemNameHelper";
    import { computed } from "vue";

    import OrderItemOption from "./OrderItemOption.vue";

    const optionGroupName = computed(() =>
        props.alwaysShowGroupName
            ? getName(props.optionGroup, false)
            : getName(props.optionGroup, props.showInternalNames)
    );
    const shouldDisplayName = computed(
        () => (props.alwaysShowGroupName || props.optionGroup.displayName) && optionGroupName.value != null
    );

    // define properties
    const props = defineProps<{
        optionGroup: IOrderOptionGroup;
        multiplier: number;
        showInternalNames: boolean;
        alwaysShowGroupName?: boolean;
    }>();
</script>

<style scoped lang="scss">
    @use "./../../../assets/styles/scss/shared/_variables.scss";

    .order-item-option-group {
        font-size: 12px;

        > .name {
            font-style: italic;
            line-height: 1.5em;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
</style>
